import React from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa'; // Import WhatsApp icon
import Header from './common/Header';
import Homepage from './pages/Homepage.js';
import Footer from './common/Footer';
import AboutUs from './pages/AboutUs.jsx';
import ContactUs from './pages/ContactUs.jsx';
import Blog from './pages/Blog.jsx';
import LoginSignup from './auth/LoginSignup.jsx';
import BookNow from './pages/BookNow.jsx';
import Profile from './pages/Profile.jsx';
import Admin from './pages/Admin.jsx';
import MyOrders from './pages/myOrders.jsx';
import { UserProvider } from './context/UserContext.jsx';
import ResetPassword from './auth/ResetPassword.js';
import FranchiseEnquiry from './pages/FranchiseEnquiry.js';
import './styles/WhatsAppIcon.css'; // Import custom CSS

// WhatsApp configuration
const WHATSAPP_PHONE_NUMBER = '+919894150416'; // Replace with your phone number (e.g., 1234567890 for +1234567890)
const WHATSAPP_MESSAGE = 'I want to rent a bike, can you please share more details?'; // Pre-filled message
const ENCODED_MESSAGE = encodeURIComponent(WHATSAPP_MESSAGE); // URL-encode the message

const App = () => (
  <UserProvider>
    <Router>
      <div className="font-inter flex flex-col min-h-screen">
        <Header />
        <Routes>
          <Route path="/" element={<Homepage />} /> 
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/login" element={<LoginSignup />} />
          <Route path="/book" element={<BookNow />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/orders" element={<MyOrders />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/franchise" element={<FranchiseEnquiry />} />
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {/* WhatsApp Icon with Pre-filled Message */}
        <a
  href={`https://wa.me/${WHATSAPP_PHONE_NUMBER}?text=${ENCODED_MESSAGE}`}
  target="_blank"
  rel="noopener noreferrer"
  className="whatsapp-icon"
  aria-label="Contact us on WhatsApp"
>
  <FaWhatsapp size={24} />
  <span className="whatsapp-label">Book via WhatsApp / Enquire</span>
</a>

        <Footer />
      </div>
    </Router>
  </UserProvider>
);

export default App;